export class EnvironmentConfigurations {
    CMS_HOST: string;
    GTM: string;
    ADOBE_SCRIPT?:string;
    MAP_KEY: string;
    CARAMEL_CATEGORY?: string;
    B2C_PRORATA_TOTAL_VALUE?:any[];
    ADDONS_DEFAULT_CATEGORIES?: any;
    ROAMING_FREQUENTRLY_VISITED_COUNTRIES: string[];
    PARENTAL_CONTROL_ADDONS: string;
    MOBILE_VIEW_ADDONS_TABS_GENERAL: any[];
    MOBILE_VIEW_ADDONS_TABS_ELIFE: any[];
    ESHOP_ADDONS_CATEGORIES?:any;
    ERROR_CODES: any;
    CMS_URL_NEW_FRAGMENTPATH: string;
    ADDONS_VAT_ELIGIBILITY_ACCOUNT_TYPES: any;
    NORTH_LADDER_URL:any;
    NORTH_LADDER_URL_AR:any;
    ARENA_PRO_PRODUCT_CATEGORY: any;
    CNAP_EMAIL:any;
    HYBRID_PLANS_CONTENT_PASS_ID: string;
    MAX_PASS_COUNT_ALLOWED: any;
    ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW: any;
    CONTENT_PASSES_CATEGORIES: any;
    ENABLE_OTP_AUTHERIZATION_ADDONS: any;
    IS_VISITOR_ORDER_ID_DECRYPT_ENABLED: any;
}